import styled from "styled-components";

import Checkbox from "./Checkbox.styles";

export type Sizes = "sm" | "md" | "lg";

export interface TrProps {
  size?: Sizes;
}

export const Tr = styled.div<TrProps>`
  background-color: var(--section-snow-background-color, var(--snow));
  height: 44px;

  @media (min-width: 366px) {
    height: ${({ size }) => {
      switch (size) {
        case "lg":
          return "72px";
        case "sm":
          return "44px";
        case "md":
        default:
          return "64px";
      }
    }};
  }

  display: flex;
  flex-direction: row;
  align-items: center;

  padding-top: 0;
  padding-bottom: 0;
  padding-left: 24px;
  padding-right: 16px;
  box-sizing: border-box;

  border-radius: 4px;
  box-shadow: 0 0 0 transparent;

  transition: 0.25s;
  transition-property: box-shadow;

  @media (min-width: 768px) {
    ${Checkbox} {
      display: none;
    }
  }

  > :last-child {
    margin-left: auto;
  }

  :hover {
    box-shadow: 0px 4px 8px
      var(--section-granite-shadow-box-shadow-color, var(--granite-shadow));
    ${Checkbox} {
      display: flex;
    }
  }

  ${Checkbox}[data-state="checked"] {
    display: flex !important;
  }
`;
